import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=2ec45642&scoped=true"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec45642",
  null
  
)

export default component.exports